function deriveId(obj) {
  if (!obj || typeof obj !== 'object') return undefined;
  return (
    obj.id ??
    obj.id_chantier ??
    obj._id ??
    obj.chantierId ??
    obj.ID ??
    obj.ID_CHANTIER ??
    obj.uuid ??
    undefined
  );
}

export default function getId(entity) {
  return deriveId(entity);
}

export function getChantierId(chantier) {
  return deriveId(chantier);
}
